import { Link } from "react-router-dom";
import { Bar, CartesianGrid, ComposedChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis, Legend } from "recharts";
import { gbp, num, YEARS } from "@/lib/api";
import { Panel } from "@/components/tam/ui";

const yearLabel = (y) => (y === "2026" ? "2026 (Jan–Jun)" : y);

export function TradingHistory({ account }) {
  const data = YEARS.map((y) => ({ year: yearLabel(y), value: account.years[y]?.value || 0, qty: account.years[y]?.qty || 0 }));
  return (
    <div className="space-y-6">
      <div className="grid lg:grid-cols-12 gap-6">
        <Panel title="Trading by year" className="lg:col-span-8" testId="trading-chart">
          <div className="h-72">
            <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={200}>
              <ComposedChart data={data}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" />
                <XAxis dataKey="year" tick={{ fontSize: 12 }} />
                <YAxis yAxisId="v" tickFormatter={(v) => `£${num(v)}`} tick={{ fontSize: 11 }} />
                <YAxis yAxisId="q" orientation="right" tick={{ fontSize: 11 }} />
                <Tooltip formatter={(v, n) => (n === "Value" ? gbp(v) : num(v))} />
                <Legend />
                <Bar yAxisId="v" dataKey="value" name="Value" fill="#0B132B" radius={[3, 3, 0, 0]} />
                <Line yAxisId="q" dataKey="qty" name="Qty" stroke="#D9232A" strokeWidth={2} />
              </ComposedChart>
            </ResponsiveContainer>
          </div>
        </Panel>
        <Panel title="Summary" className="lg:col-span-4" testId="trading-summary">
          <table className="w-full text-sm">
            <tbody>
              {data.map((d) => (
                <tr key={d.year} className="border-b border-slate-100">
                  <td className="py-2">{d.year}</td><td className="py-2 text-right font-mono">{gbp(d.value)}</td><td className="py-2 text-right font-mono text-slate-500">{num(d.qty)} qty</td>
                </tr>
              ))}
              <tr className="font-semibold"><td className="py-2">Total</td><td className="py-2 text-right font-mono">{gbp(account.total_value)}</td><td className="py-2 text-right font-mono">{num(account.total_qty)} qty</td></tr>
            </tbody>
          </table>
        </Panel>
      </div>
      <Panel title={`Products purchased (${account.lines.length})`} testId="product-lines-panel">
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[760px]">
            <thead className="text-xs uppercase text-slate-500 text-left">
              <tr><th className="pb-2">Code</th><th className="pb-2">Description</th>{YEARS.map((y) => <th key={y} className="pb-2 text-right">{y}</th>)}<th className="pb-2 text-right">Total</th></tr>
            </thead>
            <tbody>
              {[...account.lines].sort((a, b) => b.total_value - a.total_value).map((l, i) => (
                <tr key={`${l.code}-${i}`} className="border-t border-slate-100" data-testid={`product-line-${l.code}`}>
                  <td className="py-2 font-mono text-xs"><Link to={`/products/${encodeURIComponent(l.code)}`} className="hover:text-[#D9232A]">{l.code}</Link></td>
                  <td className="py-2">{l.description}</td>
                  {YEARS.map((y) => <td key={y} className="py-2 text-right font-mono text-xs">{l.years[y] ? <>{gbp(l.years[y].value)}<span className="block text-slate-500">{num(l.years[y].qty)} qty</span></> : "—"}</td>)}
                  <td className="py-2 text-right font-mono font-semibold">{gbp(l.total_value)}<span className="block text-xs font-normal text-slate-500">{num(l.total_qty)} qty</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Panel>
    </div>
  );
}
